import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import swal from 'sweetalert2';
import { forkJoin } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-modal-registro-tramite',
  templateUrl: './modal-registro-tramite.component.html',
  styleUrls: ['./modal-registro-tramite.component.css']
})
export class ModalRegistroTramiteComponent implements OnInit {
  @Input() tramite: any;
  @Input() data: any;
  @Output() onGuardar = new EventEmitter<void>();
  @ViewChild('apepatInput', { static: false }) apepatInput!: ElementRef;
  @ViewChild('traSelect', { static: false }) traSelect!: NgSelectComponent;

  // Estados y control
  isEditMode = false;
  viewMode = false;
  loading = false;
  bloquearCamposEdit = false;
  bloquearAdminist = false;

  // Variables del formulario
  lic_id = '0';
  usu_id = '0';
  per_id = '0';
  tdi_id: number = 1;
  ard_id = '0';
  lid_chkloc = '0';
  tra_id = 0;
  lid_id = '0';
  doc_id = '0';

  lid_fecemi = '';
  lid_numcop = '';
  lid_numexp = '';
  lid_numdoc = '';
  lid_apepat = '';
  lid_apemat = '';
  lid_nombre = '';
  lid_tramit = '';
  lid_docume = '';
  lid_observ = '';
  lid_chksgd = false;

  lid_razonsocial = '';

  desbloquearNombres = false;
  isNumCopDisabledFromTra = false;

  // Arrays para selects
  dataDocumentos: any[] = [];
  dataTramites: any[] = [];
  dataArea: any[] = [];
  dataTipoDoc: any[] = [];

  alertMessage = '';
  alertType = ''; // 'success' | 'warning' | 'danger'
  showAlert = false;

  get isUnidadFuncionalVisible(): boolean {
    return Number(this.tdi_id) === 2 && this.lid_numdoc === sessionStorage.getItem('rucllam');
  }

  get isUnidadFuncionalDisabled(): boolean {
    if (this.bloquearCamposEdit) return true;
    if (this.isUnidadFuncionalVisible) {
      return false;
    }
    return true;
  }

  constructor(
    public modalRef: BsModalRef,
    private api: ApiService
  ) {
    this.lid_fecemi = this.getCurrentDate();
  }

  ngOnInit(): void {
    this.loadInitialData();
    if (this.data) {
      this.isEditMode = this.data.isEditMode || false;
      this.viewMode = this.data.viewMode || false;
      this.lic_id = this.data.lic_id || '0';
      this.usu_id = this.data.usu_id || '0';

      if (!this.isEditMode && !this.viewMode && this.data.ard_id) {
        this.ard_id = this.data.ard_id;
      }
    }
    if (this.tramite) {
      this.asignarDatos(this.tramite);
    }
    if (this.viewMode) {
      this.bloquearCamposEdit = true;
    }
  }

  asignarDatos(data: any): void {
    this.lid_id = data.lid_id || '0';
    this.lic_id = data.lic_id || '0';
    this.lid_fecemi = data.lid_fecemi || this.getCurrentDate();
    this.lid_numcop = data.lid_numcop || '1';
    this.lid_numexp = data.lid_numexp || '';
    this.lid_docume = data.lid_docume || '';
    this.lid_numdoc = data.per_numdoi || '';
    this.lid_tramit = data.lid_tramit || '';
    this.lid_observ = data.lid_observ || '';
    this.tdi_id = Number(data.tdi_id) || 0;
    this.doc_id = data.doc_id || '0';
    this.ard_id = data.ard_id || '0';
    this.lid_chkloc = data.lid_chkloc || '0';
    this.lid_chksgd = data.lid_chksgd === 1 || data.lid_chksgd === true;
    this.tra_id = data.tra_id || 0;

    if (this.tdi_id != 2) {
      this.lid_apepat = data.pen_apepat || '';
      this.lid_apemat = data.pen_apemat || '';
      this.lid_nombre = data.pen_nombre || '';
    } else {
      this.lid_razonsocial = data.per_nombre || '';
    }
    this.bloquearAdminist = true;
  }

  bloquearCampos(): void {
    setTimeout(() => {
      const inputs = document.querySelectorAll('input, select, textarea, button, ng-select');
      inputs.forEach(el => {
        const element = el as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement;
        if (!element.classList.contains('btn-danger')) {
          element.disabled = true;
        }
      });
    }, 200);
  }

  onInputNumber(event: any, field: string) {
    const value = event.target.value.replace(/[^0-9]/g, '');
    (this as any)[field] = value;
  }

  onInputText(event: any, field: string) {
    const value = event.target.value.toUpperCase().trimStart();
    (this as any)[field] = value;
  }
  onKeyPress(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  private getCurrentDate(): string {
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, '0');
    const dd = String(hoy.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  loadInitialData(): void {
    this.loading = true;

    forkJoin([
      this.api.getdocumentossel({ p_doc_id: 0, p_doc_activo: 1 }),
      this.api.gettramitesel({ p_tra_id: 0, p_tra_activo: 1 }),
      this.api.getareadenominacionsel({
        p_ard_id: 0,
        p_acl_id: 0,
        p_arj_id: 0,
        p_atd_id: 0,
        p_ard_activo: 1
      }),
      this.api.getmastertipodocidesel({ p_tdi_id: 0, p_tpe_id: 0 })
    ]).subscribe({
      next: (results: any[]) => {
        this.dataDocumentos = Array.isArray(results[0]) ? results[0] : (results[0] && results[0].data ? results[0].data : []);
        this.dataTramites = Array.isArray(results[1]) ? results[1] : (results[1] && results[1].data ? results[1].data : []);
        this.dataArea = Array.isArray(results[2]) ? results[2] : (results[2] && results[2].data ? results[2].data : []);
        this.dataTipoDoc = Array.isArray(results[3]) ? results[3] : (results[3] && results[3].data ? results[3].data : []);
        if (!this.isEditMode && !this.viewMode) {
          this.tdi_id = 1;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar datos iniciales:', err);
        this.loading = false;
        swal.fire('Error', 'No se pudieron cargar los datos iniciales', 'error');
      }
    });
  }

  loadItemData(): void {
    const initialState = (this.modalRef as any).initialState || {};

    this.lid_id = initialState.lid_id || '0';
    this.lic_id = initialState.lic_id || this.lic_id;
    this.usu_id = initialState.usu_id || this.usu_id;
    this.ard_id = initialState.ard_id || this.ard_id;
    this.tdi_id = Number(initialState.tdi_id) || this.tdi_id;
    this.tra_id = initialState.tra_id || this.tra_id;
    this.doc_id = initialState.doc_id || this.doc_id;
    this.lid_chkloc = initialState.lid_chkloc || '0';
    this.lid_fecemi = initialState.lid_fecemi || this.getCurrentDate();
    this.lid_numcop = initialState.lid_numcop || '';
    this.lid_numexp = initialState.lid_numexp || '';
    this.lid_docume = initialState.lid_docume || '';
    this.lid_apepat = initialState.pen_apepat || '';
    this.lid_apemat = initialState.pen_apemat || '';
    this.lid_nombre = initialState.pen_nombre || '';
    this.lid_numdoc = initialState.lid_numdoc || '';
    this.lid_tramit = initialState.lid_tramit || '';
    this.lid_observ = initialState.lid_observ || '';
    this.lid_chksgd = initialState.lid_chksgd === 1 || initialState.lid_chksgd === true;

    if (this.viewMode) {
      setTimeout(() => {
        const inputs = document.querySelectorAll('input, select, textarea, button');
        inputs.forEach(el => (el as HTMLInputElement).disabled = true);
      }, 200);
    }
  }

  shouldShowDetalleTramit(): boolean {
    const tramite = this.dataTramites.find(t => t.tra_id === this.tra_id);
    return tramite ? tramite.tra_chkotr === 1 : false;
  }

  onTramiteChange(event: any): void {
    const tramite = this.dataTramites.find(t => t.tra_id === this.tra_id);
    if (tramite) {
      if (tramite.tra_numcop > 0) {
        this.lid_numcop = String(tramite.tra_numcop);
        this.isNumCopDisabledFromTra = true;
      } else {
        this.lid_numcop = '';
        this.isNumCopDisabledFromTra = false;
      }
    } else {
      this.lid_numcop = '';
      this.isNumCopDisabledFromTra = false;
    }
  }

  onTipoDocChange(): void {
    if (Number(this.tdi_id) === 1) {
      this.desbloquearNombres = false;
    } else {
      this.desbloquearNombres = true;
      this.lid_apepat = '';
      this.lid_apemat = '';
      this.lid_nombre = '';
    }
  }

  onSgdChange(checked: boolean): void {
    if (!checked) {
      this.lid_numexp = '';
    }
  }

  canConsultReniec(): boolean {
    return Number(this.tdi_id) === 1;
  }

  onBlurConsulta() {
    this.clearPersonaData();
    this.lid_razonsocial = '';

    if (Number(this.tdi_id) === 1) {
      this.buscarPersonaPorDni();
    } else if (Number(this.tdi_id) === 2) {
      this.buscarRuc();
    }
  }

  buscarPersonaPorDni(): void {
    if (!this.canConsultReniec()) return;
    if (this.lid_numdoc.length !== 8) return;

    this.showAlert = false;

    function encode(value: string): string {
      return btoa(value.split('').reverse().join(''));
    }

    const fed = sessionStorage.getItem('fed_numdoi') || '0';
    const usuario = sessionStorage.getItem('usuario') || '0';
    const sstid = sessionStorage.getItem('sstid') || '0';

    this.api.getconsultadni({
      nuDniConsulta: this.lid_numdoc,
      fed_numdoi: encode(fed),
      u: usuario,
      sst: sstid
    }).subscribe({
      next: (res: any) => {
        if (res.success && res.data) {
          const p = res.data;
          let apepat = '';
          let apemat = '';
          let nombre = '';
          if (res.source === 'database') {
            apepat = p.pen_apepat || '';
            apemat = p.pen_apemat || '';
            nombre = p.pen_nombre || '';
          } else if (res.source === 'reniec_inserted') {
            if (p.pen_apepat || p.pen_apemat || p.pen_nombre) {
              apepat = p.pen_apepat || '';
              apemat = p.pen_apemat || '';
              nombre = p.pen_nombre || '';
            }
            else if (p.consultarResponse && p.consultarResponse.return && p.consultarResponse.return.datosPersona) {
              let datosPersona = p.consultarResponse.return.datosPersona;
              apepat = datosPersona['apPrimer'] || '';
              apemat = datosPersona['apSegundo'] || '';
              nombre = datosPersona['prenombres'] || '';
            }
          }

          if (apepat || apemat || nombre) {
            this.lid_apepat = apepat;
            this.lid_apemat = apemat;
            this.lid_nombre = nombre;

            this.desbloquearNombres = false;

            this.alertType = 'success';
            this.alertMessage = 'Datos encontrados correctamente.';
            this.showAlert = true;
            setTimeout(() => this.showAlert = false, 2000);
            /* setTimeout(() => {
              if (this.traSelect) {
                this.traSelect.focus();
              }
            }, 150); */
          } else {
            this.clearPersonaData();
            this.desbloquearNombres = true;

            this.alertType = 'warning';
            this.alertMessage = 'No se encontraron datos registrados.';
            this.showAlert = true;
            setTimeout(() => this.showAlert = false, 2000);
            /* setTimeout(() => {
              if (this.traSelect) {
                this.traSelect.focus();
              }
            }, 150); */
          }
        } else {
          this.clearPersonaData();
          this.desbloquearNombres = true;

          this.alertType = 'warning';
          this.alertMessage = 'No se encontraron datos registrados.';
          this.showAlert = true;
          setTimeout(() => this.showAlert = false, 2000);
          /* setTimeout(() => {
            if (this.traSelect) {
              this.traSelect.focus();
            }
          }, 150); */
        }
      },
      error: () => {
        this.clearPersonaData();
        this.desbloquearNombres = true;

        this.alertType = 'danger';
        this.alertMessage = 'No se encontraron datos registrados.';
        this.showAlert = true;
        setTimeout(() => this.showAlert = false, 2000);

        setTimeout(() => {
          if (this.apepatInput && this.apepatInput.nativeElement) {
            this.apepatInput.nativeElement.focus();
          }
        }, 150);
      }
    });
  }

  buscarRuc(): void {
    if (this.lid_numdoc.length === 11) {
      if (!(this.lid_numdoc.startsWith('20') || this.lid_numdoc.startsWith('15'))) {
        this.alertType = 'warning';
        this.alertMessage = 'El RUC debe iniciar con 20 o 15.';
        this.showAlert = true;
        setTimeout(() => this.showAlert = false, 2000);
        return;
      }
    } else {
      return;
    }

    this.showAlert = false;

    const fed = sessionStorage.getItem('fed_numdoi') || '0';
    const usuario = sessionStorage.getItem('usuario') || '0';
    const sstid = sessionStorage.getItem('sstid') || '0';

    this.api.getconsultaruc({ nuRucConsulta: this.lid_numdoc, fed_numdoi: fed, u: usuario, sst: sstid }).subscribe({
      next: (res: any) => {
        if (res.success && res.data) {
          const razon = res.data.per_nomcom || res.data.pen_nombre || '';
          if (razon) {
            this.lid_razonsocial = razon;
            this.lid_nombre = razon;
            this.desbloquearNombres = false;
            this.alertType = 'success';
            this.alertMessage = 'RUC encontrado correctamente.';
            this.showAlert = true;
            setTimeout(() => this.showAlert = false, 2000);
            setTimeout(() => {
              if (this.traSelect) {
                this.traSelect.focus();
              }
            }, 150);
          } else {
            this.handleRucNoEncontrado();
          }
        } else {
          this.handleRucNoEncontrado();
        }
      },
      error: () => {
        this.handleRucNoEncontrado();
      }
    });
  }

  private handleRucNoEncontrado() {

    this.lid_razonsocial = '';
    this.desbloquearNombres = true;

    this.alertType = 'warning';
    this.alertMessage = 'No se encontraron datos del RUC.';
    this.showAlert = true;

    setTimeout(() => this.showAlert = false, 2000);
  }

  private clearPersonaData(): void {
    this.lid_apepat = '';
    this.lid_apemat = '';
    this.lid_nombre = '';
  }

  guardarTramite(): void {
    if (this.shouldShowDetalleTramit() && !this.lid_tramit) {
      swal.fire('Advertencia', 'Debe ingresar el detalle del trámite', 'warning');
      return;
    }

    const jsn_admini = [{
      tdi_id: Number(this.tdi_id).toString(),
      tdi_numero: this.lid_numdoc,
      per_apepat: this.lid_apepat,
      per_apemat: this.lid_apemat,
      per_nombre: Number(this.tdi_id) === 2 ? this.lid_razonsocial : this.lid_nombre
    }];

    const data_post = {
      p_lid_id: parseInt(this.lid_id),
      p_lic_id: parseInt(this.lic_id),
      p_doc_id: parseInt(this.doc_id),
      p_tra_id: this.tra_id,
      p_ard_id: parseInt(this.ard_id),
      p_lid_chkloc: this.isUnidadFuncionalVisible ? 1 : 0,
      p_lid_fecemi: this.lid_fecemi,
      p_lid_numcop: parseInt(this.lid_numcop),
      p_lid_chksgd: this.lid_chksgd ? 1 : 0,
      p_lid_tramit: this.lid_tramit,
      p_lid_docume: this.lid_docume,
      p_lid_numexp: this.lid_numexp,
      p_lid_observ: this.lid_observ,
      p_jsn_admini: jsn_admini,
      p_lid_usumov: parseInt(this.usu_id)
    };

    this.loading = true;
    this.api.getlibrodetgra(data_post).subscribe({
      next: (res: any) => {
        this.loading = false;
        const result = Array.isArray(res) ? res[0] : res;
        if (result && result.error === 0) {
          swal.fire('Éxito', result.mensa || 'Registro guardado correctamente', 'success')
            .then(() => {
              this.onGuardar.emit();
              this.modalRef.hide();
            });
        } else {
          swal.fire('Error', (result && result.mensa) ? result.mensa : 'Ocurrió un error al guardar', 'error');
        }
      },
      error: (err) => {
        this.loading = false;
        swal.fire('Error', 'Ocurrió un error al guardar el registro', 'error');
      }
    });
  }

  cerrarModal(): void {
    this.modalRef.hide();
  }
}
